import { useState } from "react";
import { getCustomisationValue, getGroupData } from "../../../EditablePreview";
import InlineProgressBar, { convertCustomisationDataToBarSettings } from "../../progress-bar/inline-progress-bar";
import VisualisedNode, { IMAGE_MODES } from "../../VisualisedNode";
import './WaveProgressBar.scss';

const WaveProgressBar = (props) => {
    console.log("WaveProgressBar props:", props);

    const leftImageSettings = getGroupData(props.node.customisationVars, 'progressBar.extras.leftImage');
    const rightImageSettings = getGroupData(props.node.customisationVars, 'progressBar.extras.rightImage');
    const centerImageSettings = getGroupData(props.node.customisationVars, 'progressBar.extras.centerImage');
    const progressLockImageSettings = getGroupData(props.node.customisationVars, 'progressBar.extras.progressImage');

    const positionSetting = getCustomisationValue(props.node.customisationVars, 'progressBar.shapeAndPosition.position.position');
    console.log("Position setting:", positionSetting);
    const dir = (positionSetting === 'left' || positionSetting === 'right') ? 'vertical' : 'horizontal';

    const percBarWidth = (dir === 'horizontal' ? 1920 : 1080) * (getCustomisationValue(props.node.customisationVars, 'progressBar.shapeAndPosition.shape.length') / 100) * props.previewScale;
    const percBarHeight = getCustomisationValue(props.node.customisationVars, 'progressBar.shapeAndPosition.shape.thickness') * props.previewScale;

    const leftImageLeft = 
        dir === 'horizontal' ? (leftImageSettings?.offsetX ? leftImageSettings.offsetX * props.previewScale : 0) + 'px'
                            : `calc(50% + ${leftImageSettings?.offsetX ? leftImageSettings.offsetX * props.previewScale + 'px' : '0px'})`;
    const leftImageTop = 
        dir === 'horizontal' ? `calc(50% + ${leftImageSettings?.offsetY ? leftImageSettings.offsetY * props.previewScale + 'px' : '0px'})`
                            : percBarWidth + (leftImageSettings?.offsetY ? leftImageSettings.offsetY * props.previewScale : 0) + 'px';
    const rightImageLeft = 
        dir === 'horizontal' ? percBarWidth + (rightImageSettings?.offsetX ? rightImageSettings.offsetX * props.previewScale : 0) + 'px'
                            : `calc(50% + ${rightImageSettings?.offsetX ? rightImageSettings.offsetX * props.previewScale + 'px' : '0px'})`;
    const rightImageTop = 
        dir === 'horizontal' ? `calc(50% + ${rightImageSettings?.offsetY ? rightImageSettings.offsetY * props.previewScale + 'px' : '0px'})`
                            : (rightImageSettings?.offsetY ? rightImageSettings.offsetY * props.previewScale : 0) + 'px';

    const centerImageLeft = dir === 'horizontal' ? `calc(50% + ${centerImageSettings?.offsetX ? centerImageSettings.offsetX * props.previewScale + 'px' : '0px'})`
        : `calc(50% + ${centerImageSettings?.offsetY ? centerImageSettings.offsetY * props.previewScale + 'px' : '0px'})`
    const centerImageTop = dir === 'horizontal' ? `calc(50% + ${centerImageSettings?.offsetY ? centerImageSettings.offsetY * props.previewScale + 'px' : '0px'})`
        : `calc(50% + ${centerImageSettings?.offsetX ? centerImageSettings.offsetX * props.previewScale + 'px' : '0px'})`;

    const progressImageLeft = dir === 'horizontal' ? `calc(70% + ${progressLockImageSettings?.offsetX ? progressLockImageSettings.offsetX * props.previewScale + 'px' : '0px'})`
        : `calc(50% + ${progressLockImageSettings?.offsetY ? progressLockImageSettings.offsetY * props.previewScale + 'px' : '0px'})`
    const progressImageTop = dir === 'horizontal' ? `calc(50% + ${centerImageSettings?.offsetY ? centerImageSettings.offsetY * props.previewScale + 'px' : '0px'})`
        : `calc(30% + ${centerImageSettings?.offsetX ? centerImageSettings.offsetX * props.previewScale + 'px' : '0px'})`;

    return (
        <div className="wave-progress-bar-holder" style={{margin: 50 * props.previewScale, width: '100%'}}>
            <VisualisedNode
                {...props}
                node={props.node.subNodes[1]}
                imageMode={IMAGE_MODES.naturalSize}
                style={{
                    position: 'absolute',
                    left: leftImageLeft,
                    top: leftImageTop,
                    transform: `translate(-50%, ${dir === 'horizontal' ? '-50%' : `-${(1 - props.previewScale) / 2 * 100}%`})`,
                    zIndex: 1,
                }}
            />
            <VisualisedNode
                {...props}
                dir={dir}
                stripeWidth={10}
                node={props.node.subNodes[0]}
                cornerRadiusDivider={2}
                style={
                    {
                        minWidth: dir === 'horizontal' ? percBarWidth : percBarHeight,
                        minHeight: dir === 'horizontal' ? percBarHeight : percBarWidth,
                    }
                }
            />
            <VisualisedNode
                {...props}
                node={props.node.subNodes[2]}
                imageMode={IMAGE_MODES.naturalSize}
                style={{
                    position: 'absolute',
                    left: rightImageLeft,
                    top: rightImageTop,
                    transform: `translate(-50%, ${dir === 'horizontal' ? '-50%' : `-${(1 - props.previewScale) / 2 * 100}%`})`,
                    zIndex: 1,
                }}
            />
            <VisualisedNode
                {...props}
                node={props.node.subNodes[3]}
                imageMode={IMAGE_MODES.naturalSize}
                style={{
                    position: 'absolute',
                    left: centerImageLeft,
                    top: centerImageTop,
                    transform: `translate(-50%, -50%) rotate(${dir === 'horizontal' ? '0deg' : '-90deg'})`,
                    zIndex: 1,
                }}
            />
            <VisualisedNode
                {...props}
                node={props.node.subNodes[4]}
                imageMode={IMAGE_MODES.naturalSize}
                style={{
                    position: 'absolute',
                    left: progressImageLeft,
                    top: progressImageTop,
                    transform: `translate(-50%, -50%) rotate(${dir === 'horizontal' ? '0deg' : '-90deg'})`,
                    zIndex: 1,
                }}
            />
        </div>
    )
}

export default WaveProgressBar;
